export const copyToClipboard = (text, tooltipId) => {
    navigator.clipboard.writeText(text);

    const tooltip = document.getElementById(tooltipId);
    if (tooltip) {
        tooltip.classList.add('show')

        // hide the tooltip after 2 seconds
        setTimeout(function() {
            tooltip.classList.remove('show')
        }, 2000);
    }

}


// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/clipboard.js